import { render, staticRenderFns } from "./AckModal.vue?vue&type=template&id=21575147"
import script from "./AckModal.vue?vue&type=script&lang=js"
export * from "./AckModal.vue?vue&type=script&lang=js"
import style0 from "./AckModal.vue?vue&type=style&index=0&id=21575147&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports